import { useEffect, useRef } from 'react'
import { prefetchOpenRight } from 'refactor/panels/prepareOpenRight'

const HOVER_DELAY_MS = 250

export default function useOpenRightPrefetch(
    questId: string | number | null | undefined,
    answerId: string | number | null | undefined,
) {
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)
    const ids = questId && answerId ? { questId, answerId } : null
    const cancel = () => {
        if (timerRef.current) clearTimeout(timerRef.current)
        timerRef.current = null
    }
    const start = () => {
        if (!ids || timerRef.current) return
        timerRef.current = setTimeout(() => {
            timerRef.current = null
            void prefetchOpenRight(ids.questId, ids.answerId).catch(() => null)
        }, HOVER_DELAY_MS)
    }
    const startImmediate = () => {
        cancel()
        if (ids) void prefetchOpenRight(ids.questId, ids.answerId).catch(() => null)
    }
    useEffect(() => cancel, [questId, answerId])
    return {
        onMouseEnter: start,
        onMouseLeave: cancel,
        onFocus: start,
        onBlur: cancel,
        onPointerDown: startImmediate,
    }
}
